import store from "@/store";
import Parser from "@/modules/staff/services/messageParser";
import { Message } from "@/modules/staff/objects/conversation/Message";
import { ErrorService } from "@/framework/errors/ErrorService";
import {
  ConversationAction,
  ConversationMutation,
  UnReadMessage,
  UnReadMessagesByGuest,
} from "@/framework/store/conversation/types";
import { ConversationService } from "@/framework/api/Staff/ChatService/ConversationService";

export default {
  // unread message一覧を取得する
  async [ConversationAction.listUnReadMessage]({ commit }: any, currentUserId: any) {
    const res = await new ConversationService().listUnreadMessage(100);
    if (res.isErr()) {
      return await new ErrorService().handleError(res.error);
    }

    let data = res.value;
    if (!data || !data.items) {
      return;
    }
    // TODO rather than "map", consider using "reduce" instead, so that creating the weird null entries isn't necessary
    const convList = data.items.map((element: any) => {
      if (!element || store.getters.currentConversationId == element.conversation_id) {
        return null;
      }
      const unreadMessageData: UnReadMessage = {
        id: element.id as number,
        conversationId: element.conversation_id as string,
        messageId: element.message_id as string,
        sendUserId: element.send_user_id_account as number,
        unReadUserId: element.unread_user_id_account as number,
      };
      return unreadMessageData;
    });
    // unreadMessageDataを更新
    commit(ConversationMutation.SET_LOAD_UNREAD, convList);
  },
  async [ConversationAction.deleteUnReadMessage]({ commit }: any, unReadMessageId: any) {
    const res = await new ConversationService().deleteQcUnreadMessage(unReadMessageId);
    if (res.isErr()) {
      return await new ErrorService().handleError(res.error);
    }
    commit(ConversationMutation.SET_DELETE_UNREAD, res.value.id);
  },
  async [ConversationAction.readConversationAction]({ commit }: any, conversationId: any) {
    const res = await new ConversationService().readConversationStatus(conversationId);
    if (res.isErr()) {
      return await new ErrorService().handleError(res.error);
    }
  },
  // Subscription
  [ConversationAction.addSubscriptionsOnPage]({ commit, getters }: any, subscription: any) {
    let currentSubscriptionsOnPage: [any] = getters.subscriptionsOnPage;
    currentSubscriptionsOnPage.push(subscription);
    commit(ConversationMutation.SET_SUBSCRIPTIONS_ON_PAGE, currentSubscriptionsOnPage);
  },
  [ConversationAction.addEventDataList]({ commit, getters }: any, onNotifyMyEvent: any) {
    let currentEventDataList = getters.eventDataList;
    currentEventDataList.push(onNotifyMyEvent);
    commit(ConversationMutation.SET_EVENT_DATA_LIST, currentEventDataList);
  },
  async [ConversationAction.startSubscription]({ commit }: any) {
    commit(ConversationMutation.START_SUBSCRIPTION, true);
  },
  [ConversationAction.setHasStartedAppSyncSubscription]({ commit }: any, hasStartedAppSyncSubscription: boolean) {
    commit(ConversationMutation.SET_HAS_STARTED_APPSYNC_SUBSCRIPTION, hasStartedAppSyncSubscription);
  },
  [ConversationAction.unsubscribeAll]({ commit }: any) {
    commit(ConversationMutation.SET_UNSUBSCRIBE_ALL, true);
  },
  [ConversationAction.startVoiceChaInRoom]({ commit, getters }: any, onNotifyMyEvent: any) {
    commit(ConversationMutation.START_VOICE_CHAT_IN_ROOM, onNotifyMyEvent);
  },
  [ConversationAction.respondVoiceChatInRoom]({ commit, getters }: any, onNotifyMyEvent: any) {
    commit(ConversationMutation.RESPOND_VOICE_CHAT_IN_ROOM, onNotifyMyEvent);
  },
  // Guest / User
  [ConversationAction.setCurrentMessages]({ commit }: any, currentMessages: Message[]) {
    commit(ConversationMutation.SET_CURRENT_MESSAGES, currentMessages);
  },
  async [ConversationAction.addMessageToCurrentMessages]({ commit, getters }: any, message: Message) {
    let chatMessages = getters.currentMessages;
    let messageDate = Parser.createMessageDate(chatMessages);
    const parsedMessage = await Parser.parseMessage(message, messageDate, "event");
    if (!message.content && message.contents && message.contents.length == 0) {
      console.log("Add message action warning: message content(s) is empty.");
      return;
    }
    const newMessages = addNewMessageToMessages(parsedMessage, chatMessages);
    if (store.getters.user.userType === "biz_staff") {
      // Check unread messages for current conversation
      const unreadMessages: UnReadMessagesByGuest = await store.getters.getUnreadMessages;
      if (!unreadMessages || unreadMessages.conversationId !== message.messageConversationId) {
        // if the conversation id is not match or this is new message from staff which still didn't received by guest
        store.commit("SET_UNREAD_MESSAGES", {
          conversationId: message.messageConversationId,
          lastMsgId: message.id,
          unreadIds: [message.id],
        });
      } else {
        // if the conversation id is match and this is a new message from staff which still didn't received by guest
        if (
          unreadMessages &&
          unreadMessages.unreadIds &&
          unreadMessages.unreadIds.findIndex((x) => x === message.id) === -1 &&
          unreadMessages.conversationId === message.messageConversationId
        ) {
          // if (store.getters.currentMessages.findIndex((i: any) => i.id === unreadMessages.lastMsgId) === )
          const newMsgIDs = unreadMessages.unreadIds.concat(message.id);

          store.commit("SET_UNREAD_MESSAGES", {
            conversationId: message.messageConversationId,
            lastMsgId: message.id,
            unreadIds: newMsgIDs,
          });
        }
      }
    }
    commit(ConversationMutation.SET_CURRENT_MESSAGES, newMessages);
  },
  async [ConversationAction.addMessagesToCurrentMessages]({ commit, state, getters }: any, messages: Message[]) {
    if (
      messages &&
      messages.length &&
      messages[0].messageConversationId !== state.currentConversationId &&
      store.getters.user.userType === "biz_staff"
    ) {
      return;
    }
    let chatMessages = state.currentMessages;
    let messageDate = Parser.createMessageDate(chatMessages);
    let newParsedMessages: Message[] = [];
    for (const message of messages) {
      const parsedMessage = await Parser.parseMessage(message, messageDate, "event");
      newParsedMessages.push(parsedMessage);
    }
    const newMessages = addNewMessagesToMessages(messages, state.currentMessages);
    commit(ConversationMutation.SET_CURRENT_MESSAGES, newMessages);
  },
  async [ConversationAction.updateMessageInCurrentMessages]({ commit, state }: any, message: Message) {
    let messageDate = Parser.createMessageDate(state.currentMessages);
    const parsedMessage = await Parser.parseMessage(message, messageDate, "event");
    const newMessages = updateMessageInMessages(parsedMessage, state.currentMessages);
    commit(ConversationMutation.SET_CURRENT_MESSAGES, newMessages);
  },
  async [ConversationAction.deleteMessageFromCurrentMessages]({ commit, state }: any, message: Message) {
    try {
      let messageDate = Parser.createMessageDate(state.currentMessages);
      const parsedMessage = await Parser.parseMessage(message, messageDate);
      const newMessages = deleteMessageFromMessages(parsedMessage, state.currentMessages);
      await commit(ConversationMutation.SET_CURRENT_MESSAGES, newMessages);
      console.log("===========Delete Done=========", newMessages, parsedMessage, store.getters.currentMessages);
    } catch (error) {
      console.log("Error in delete message", error);
    }
  },
  // Staff
  [ConversationAction.setCurrentMessagesWithStaff]({ commit }: any, currentMessagesWithStaff: Message[]) {
    commit(ConversationMutation.SET_CURRENT_MESSAGES_WITH_STAFF, currentMessagesWithStaff);
  },
  async [ConversationAction.addMessageToCurrentMessagesWithStaff]({ commit, getters }: any, message: Message) {
    let chatMessagesWithStaff = getters.currentMessagesWithStaff;
    let messageDate = Parser.createMessageDate(chatMessagesWithStaff);
    const parsedMessage = await Parser.parseMessage(message, messageDate);
    if (!message.content && message.contents.length == 0) {
      console.log("Add message action warning: message content(s) is empty.");
      return;
    }
    const newMessages = addNewMessageToMessages(parsedMessage, getters.currentMessagesWithStaff);
    commit(ConversationMutation.SET_CURRENT_MESSAGES_WITH_STAFF, newMessages);
  },
  async [ConversationAction.addMessagesToCurrentMessagesWithStaff]({ commit, state }: any, messages: Message[]) {
    let chatMessagesWithStaff = state.currentMessagesWithStaff;
    let messageDate = Parser.createMessageDate(chatMessagesWithStaff);
    let newParsedMessages: Message[] = [];
    for (const message of messages) {
      const parsedMessage = await Parser.parseMessage(message, messageDate);
      newParsedMessages.push(parsedMessage);
    }
    const newMessages = addNewMessagesToMessages(newParsedMessages, state.currentMessagesWithStaff);
    commit(ConversationMutation.SET_CURRENT_MESSAGES_WITH_STAFF, newMessages);
  },
  async [ConversationAction.updateMessageInCurrentMessagesWithStaff]({ commit, state }: any, message: Message) {
    let messageDate = Parser.createMessageDate(state.currentMessagesWithStaff);
    const parsedMessage = await Parser.parseMessage(message, messageDate);
    const newMessages = updateMessageInMessages(parsedMessage, state.currentMessagesWithStaff);
    commit(ConversationMutation.SET_CURRENT_MESSAGES_WITH_STAFF, newMessages);
  },
  [ConversationAction.updateConversationState]({ commit, state }: any, conversationId: string) {
    // ここでは何もしない。あくまでサブスクライブされたことを通知する用
    // いろんなページで処理が違うので、諸々の処理は各ページで行う
  },
  [ConversationAction.receivedReadConversation]({ commit, state }: any, data: any) {
    // ここでは何もしない。あくまでサブスクライブされたことを通知する用
    // ゲストがスタッフのメッセージを読んだときにpwaの会話一覧にあるゲスト未読マークを消すため
  },
  [ConversationAction.receivedCreateQcUnreadConversation]({ commit, state }: any, data: any) {
    // ここでは何もしない。あくまでサブスクライブされたことを通知する用
  },
  [ConversationAction.receivedCreateQcUnrepliedConversation]({ commit, state }: any, data: any) {
    // ここでは何もしない。あくまでサブスクライブされたことを通知する用
  },
  [ConversationAction.receivedCreateUnReadMessage]({ commit, state }: any, data: any) {
    // ここでは何もしない。あくまでサブスクライブされたことを通知する用
  },
  async [ConversationAction.subscribeConversations]({ commit, state }: any) {
    try {
      const res = await new ConversationService().fetchConversationIds(state.appMode);
      if (res.isErr()) {
        return await new ErrorService().handleError(res.error);
      }
      commit(ConversationMutation.SET_CONVERSATION_IDS, res.value);
    } catch (error) {
      console.log("Error subscribeConversations: ", error);
      throw error;
    }
  },
  [ConversationAction.unsubscribeConversations]({ commit }: any) {
    commit(ConversationMutation.CLEAR_CONVERSATION_IDS);
  },
  [ConversationAction.addConversation]({ commit, state }: any, payload: string) {
    commit(ConversationMutation.ADD_CONVERSATION_ID, payload);
  },
  [ConversationAction.showNewIcon]({ commit }: any, payload: boolean) {
    commit(ConversationMutation.SET_SHOW_NEW_ICON, payload);
  },
  [ConversationAction.setImportance]({ commit }: any, payload: boolean) {
    commit(ConversationMutation.SET_IMPORTANCE, payload);
  },
  [ConversationAction.setForwardInquiryId]({ commit }: any, payload: number) {
    commit(ConversationMutation.SET_FORWARD_INQUIRY_ID, payload);
  },
  [ConversationAction.setFromInquiryHistory]({ commit }: any, payload: boolean) {
    commit(ConversationMutation.SET_FROM_INQUIRY_HISTORY, payload);
  },
  async [ConversationAction.pmsRoomServiceOrderFailed]() {
    // Due to specification change, we don't use this action for now
  },
  async [ConversationAction.pmsRoomServiceOrdered]() {
    // Due to specification change, we don't use this action for now
  },
  [ConversationAction.runningEllipse]({ commit }: any, payload: any) {
    commit(ConversationMutation.SET_RUNNING_ELLIPSE, payload);
  },
  [ConversationAction.guestRunningEllipse]({ commit }: any, payload: any) {
    commit(ConversationMutation.SET_GUEST_RUNNING_ELLIPSE, payload);
  },
};

// Helper functions
const addNewMessageToMessages = (newMessage: Message, messages: Message[]): Message[] => {
  if (messages.findIndex((element: any) => element.id === newMessage.id) >= 0) {
    return messages;
  }
  // 投稿順に並び替え
  let tmp = [...messages, newMessage];
  tmp = tmp.sort((a, b) => (a.order < b.order ? -1 : 1));
  return tmp;
};

const addNewMessagesToMessages = (newMessages: Message[], messages: Message[]): Message[] => {
  // 既存のメッセージIDリスト
  const existMessageIds = messages.map((m) => m.id);
  // 重複がないようにチェック(新しいメッセージのうち、既存のメッセージにはないものだけを抽出)
  const addMessages = newMessages.filter((m) => !existMessageIds.includes(m.id));
  let tmp = messages.concat(addMessages);
  return tmp.sort((a, b) => (a.order < b.order ? -1 : 1));
};

const updateMessageInMessages = (updatedMessage: Message, messages: Message[]): Message[] => {
  let tmp = [...messages.filter((item) => item.id !== updatedMessage.id), updatedMessage];
  return tmp.sort((a, b) => (a.order < b.order ? -1 : 1));
};

const deleteMessageFromMessages = (deletedMessage: Message, messages: Message[]): Message[] => {
  return [...messages.filter((item) => item.id !== deletedMessage.id)];
};
